import React from 'react'
import queryString from 'query-string'
import { useLocation, useParams } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import { useApplicationApiRequest } from '../hooks/useApplicationApi'

import LoadingIndicator from './LoadingIndicator'
import RecordingPlayer from './RecordingPlayer'
import {
  normalizeDeck,
  normalizeRecording,
} from './RecordingPlayer/normalizers'

const styles = (theme) => ({
  root: {
    alignItems: 'center',
    bottom: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
})
const useStyles = makeStyles(styles)

export default function PlayerContainer() {
  const { search } = useLocation()
  const { id } = useParams()

  const authorizationToken = queryString.parse(search).authorization_token

  const { isError, isLoading, response } = useApplicationApiRequest(
    `/player/${id}`,
    {
      params: {
        authorization_token: authorizationToken,
      },
    },
  )

  const classes = useStyles()

  if (
    isError ||
    isLoading ||
    !response ||
    response?.data?.status !== 'success'
  ) {
    return <LoadingIndicator />
  }

  const deck = normalizeDeck(response.data?.document)
  const recording = normalizeRecording(response.data)

  return (
    <div className={classes.root}>
      <RecordingPlayer
        deckDisabled={!deck}
        deckId={deck?.id}
        deckSlides={deck?.slides}
        deckStatus={deck?.status}
        deckStatusProgress={deck?.statusProgress}
        recordingDeckTimestamps={recording.deckTimestamps}
        recordingDisabled={!recording}
        recordingId={recording.id}
        recordingMedia={recording.media}
        recordingMediaFormat={recording.mediaFormat}
        recordingStatus={recording.status}
        recordingStatusProgress={recording.statusProgress}
      />
    </div>
  )
}
